export default __webpack_public_path__ + "static/group-do-dark-12c501e7e7cc116e7e5c3ffb93b0b99f.png";